export default __webpack_public_path__ + "static/media/scrum-event-sheets-2.0b05b8cb.png";